










import Vue from 'vue'

import AfterScreening from './AfterScreening.vue'
import AfterInterview from './AfterInterview.vue'
import AfterDropout from './AfterDropout.vue'

import { NotNull, Unpacked } from '@/utils'
import { CasesConnection } from '@/graphql-schema'
type Case = Unpacked<CasesConnection['nodes']>
type Patient = Case['patient']

export default Vue.extend({
  components: {
    AfterInterview,
    AfterScreening,
  },
  created() {
    //this.$store.dispatch({ type: 'queryCases' })
  },
  computed: {
    currentCase(): Case {
      return this.$store.getters.currentCase
    },
    patient(): Patient {
      return this.currentCase!.patient
    },
  },
})
